export const EVISITS_ROUTES = {
  OVERVIEW: '/u/e-visits/overview',
  STATE_SELECTOR: '/u/e-visits/state-selector',
  PHARMACY_SELECTOR: '/u/e-visits/pharmacy-selector',
  REQUEST_SUCCESS: '/u/e-visits/request-success'
};
